<template>
  <div :class="{'p-relative': loading}" :style="{'min-height': minHeight}">
    <loading v-if="loading" :min-height="minHeight"/>
    <transition name="fade">
      <div v-if="!loading">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import loading from "@/components/ui/loading";

export default {
  name: "preload-content",
  components: {loading},
  props: {
    minHeight: String,
    loading: Boolean,
  },
}
</script>

<style scoped>
.p-relative {
  position: relative !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}
</style>
